import { Table, Tag, Tooltip } from "antd";
import FieldInsightProgress from "components/atoms/FieldInsightProgress";
import DataTable from "components/molecules/DataTable";
import CypressTestIds from "../../../cypress/CypressTestIds";

const { Column } = Table;

const DataSetInsightsList = ({ dataSetInsightList }) => {
    return (
        <DataTable
            dataTestId={CypressTestIds.DATASET_INSIGHTS_TABLE}
            emptyText="Please select a dataset from above"
            hideSelectionColumn
            fixedHeader
            tableProps={{
                size: "small",
                rowKey: "fieldId",
                dataSource: dataSetInsightList,
                pagination: false,
                columns: [
                    {
                        width: "8rem",
                        dataIndex: "businessAreaName",
                        title: "Business Area",
                        ellipsis: {
                            showTitle: false,
                        },
                        render: (value, dataSetInsight, index) => (
                            <Tooltip placement="topLeft" title={value}>
                                {value}
                            </Tooltip>
                        ),
                    },
                    {
                        width: "12rem",
                        dataIndex: "schemaName",
                        title: "Schema",
                        ellipsis: {
                            showTitle: false,
                        },
                        render: (value, dataSetInsight, index) => (
                            <Tooltip placement="topLeft" title={value}>
                                {value}
                            </Tooltip>
                        ),
                    },
                    {
                        width: "12rem",
                        dataIndex: "dataSetName",
                        title: "DataSet",
                        ellipsis: {
                            showTitle: false,
                        },
                        render: (value, dataSetInsight, index) => (
                            <Tooltip placement="topLeft" title={value}>
                                {value}
                            </Tooltip>
                        ),
                    },
                    {
                        width: "12rem",
                        dataIndex: "fieldName",
                        title: "Attribute/Column",
                        ellipsis: {
                            showTitle: false,
                        },
                        render: (value, dataSetInsight, index) => (
                            <Tooltip placement="topLeft" title={value}>
                                {value}
                            </Tooltip>
                        ),
                    },
                    {
                        width: "12rem",
                        dataIndex: "fieldClassifiers",
                        title: "Classifiers/Tags",
                        ellipsis: {
                            showTitle: false,
                        },
                        render: (value, dataSetInsight, index) => {
                            return value && value.length > 0 ? (
                                <div className="flex gap-1">
                                    <Tag key={value[0].tagId}>{value[0].tagName}</Tag>
                                    {value.length > 1 ? (
                                        <Tooltip
                                            title={value
                                                .slice(1)
                                                .map((tag) => tag.tagName)
                                                .join(", ")}
                                        >
                                            <Tag>...</Tag>
                                        </Tooltip>
                                    ) : null}
                                </div>
                            ) : (
                                <></>
                            );
                        },
                    },
                    {
                        width: "6rem",
                        dataIndex: "fieldDataType",
                        title: "Data Type",
                        ellipsis: {
                            showTitle: false,
                        },
                        render: (value, dataSetInsight, index) => (
                            <Tooltip placement="topLeft" title={value}>
                                {value}
                            </Tooltip>
                        ),
                    },
                    {
                        width: "12rem",
                        fixed: "right",
                        dataIndex: "successDataCount",
                        title: "Validity to Schema",
                        ellipsis: {
                            showTitle: false,
                        },
                        render: (value, dataSetInsight, index) => (
                            <FieldInsightProgress
                                successDataCount={dataSetInsight.successDataCount}
                                erroredDataCount={dataSetInsight.erroredDataCount}
                                fieldDataType={dataSetInsight.fieldDataType}
                            ></FieldInsightProgress>
                        ),
                    },
                ],
            }}
        />
    );
};

export default DataSetInsightsList;
